import { RxFArtEnumRefDocument, RxFArticleDocument, RxFCompteTDocument, RxFConditionDocument, RxFNomenclatDocument, RxFTarifQteDocument } from "./@services/m-remdocs-core-rxdb";

export class CluMediaOptions { 
    LAYOUT_MOBILE_VIEW : boolean = false; 
    LAYOUT_MOBILE_VIEW_S : boolean = false; 
    LAYOUT_MOBILE_VIEW_L : boolean = false;
    LAYOUT_BELOWMONITOR : boolean = false; 
    LAYOUT_BELOWMONITOR_L : boolean = false; 
    LAYOUT_BELOWMONITOR_M : boolean = false; 
    LAYOUT_BELOWMONITOR_L1100 : boolean = false; 
    D_MODE : 'main' | 'cart' = 'main';
}



export class CluSearchResult {
    ARTICLES : RxFArticleDocument[];
    TIERS : RxFCompteTDocument[];
    ARTENUMREFS : RxFArtEnumRefDocument[];
    CONDITIONS : RxFConditionDocument[];
}

export class CluSearchItemPickedResult {
    TYPE : 'ARTICLE' | 'TIERS';
    VALUE_ARTICLE : RxFArticleDocument | undefined;
    VALUE_TIERS : RxFCompteTDocument | undefined;
}

export class CluArtGammesPickedResult {
    AG_NO1 : number = 0;
    AG_NO1LIB : string = '';
    AG_NO2 : number = 0;
    AG_NO2LIB : string = '';
}

export class CluConditionPickedResult {
    NO_CONDITION : boolean;
    VALUE_CONDITION : RxFConditionDocument | undefined;
    TC_PRIX_U : number;
}

export class CluArtFamComptaItem {
    N_CATCOMPTA? : number;
    DL_CODETAXE1? : string;
    DL_LIBTAXE1? : string;
    DL_TAXE1? : number;
    DL_TYPETAXE1? : number;
    DL_TYPETAUX1? : number;
    DL_CODETAXE2? : string;
    DL_LIBTAXE2? : string;
    DL_TAXE2? : number;
    DL_TYPETAXE2? : number;
    DL_TYPETAUX2? : number;
    DL_CODETAXE3? : string;
    DL_LIBTAXE3? : string;
    DL_TAXE3? : number;
    DL_TYPETAXE3? : number;
    DL_TYPETAUX3? : number;
}

export class CluNomenclatureItem {
    NOMENCLATURE : RxFNomenclatDocument;
    PARENT_ARTICLE : RxFArticleDocument;
    REF_ARTICLE : RxFArticleDocument;
    REF_ARTICLE_ARTGAMME : CluArtGammesPickedResult | undefined;
}

export class CluLotSerieItemPickedResult {
    CANCELED : boolean;
    PICKED_ITEMS : CluLotSeriePickedItemResult[] = [];
}

export class CluLotSeriePickedItemResult {
    DE_NO : number = 0;
    DE_INTITULE : string = '';
    LS_NOSERIE : string = '';
    LS_COMPLEMENT : string = '';
    LS_PEREMPTION : Date | undefined;
    LS_FABRICATION : Date | undefined;
    LS_QTE : number = 0;
}


export class CluDiscountResult {
    DL_REMISE_LIB : string;
    DL_REMISE01REM_VALEUR : number = 0;
    DL_REMISE01REM_TYPE : number = 0;
    DL_REMISE02REM_VALEUR : number = 0;
    DL_REMISE02REM_TYPE : number = 0;
    DL_REMISE03REM_VALEUR : number = 0;
    DL_REMISE03REM_TYPE : number = 0;
}

export class CluDefaultRemisesResult {
    SPECREM_FOUND : boolean = false;
    
    SPECREM_ARTICLE_FOUND : boolean = false;
    TYPEREM : number = 0;
    QTEMONT : number = 0;
    REM : number = 0;
    TARIFQTE_ITEMS : RxFTarifQteDocument[] = [];

    SPECREM_COMPTET_FOUND : boolean = false;
    REM_COMPTET : number = 0;
    REM_CONFLICT_MODE : number = 0;
}

export class CluPrintResult {
    MODE : 'canceled' | 'print' | 'print_n' | 'email' = 'canceled';
    PRINTED_N : number = 0;
    EMAIL_1 : string = '';
    EMAIL_2 : string = '';
    EMAIL_3 : string = '';
}

export class CluCarteCadeauxItemPickedResult {
    CANCELED : boolean;

    DL_GF_CARTE_NUM : string = '';
    DL_GF_CARTE_DESIGNATION : string = '';
    DL_GF_C_TOTAL_TTC_INIT : number = 0;
    DL_GF_DATE_DEBUT : Date;
    DL_GF_DATE_EXP : Date;
}

export class CLU_RECOMPENSE_TYPE {
    public static R_REMISE_GLOBALE : number = 1;
    public static R_REMISE_LIGNE_P : number = 2;
    public static R_REMISE_GLOBALE_MT : number = 3;
    public static R_REMISE_LIGNE_MT : number = 4;
    public static R_AR_GRATUITE : number = 5;
    public static R_AR_TARIFPREFERENTIEL : number = 6;
}

export class CluLoyaltyCardRecompenseParams {
    LC_REC_PTS_NB : number = 0;
    LC_PG_GID : string;
    LC_REC_GID : string;
    LC_REC_TYPE : number = 0;
}

export class CluBilanTaxeItem {
    DL_CODETAXE : string = '';
    DL_TAXELIB : string = '';
    T_BASE : string = '';
    T_TAUX : number;
    T_MONTANT : number;
}

export class CluCustomInputItem {
    FIELD_ORIG : 'DL' | 'CL_DL';
    FIELD : string;
    FIELD_LIB : string;
    TYPE : number;
    TYPE_LIB : string;
    MAX_LENGTH : number = 0;
}
